export function getFeatureFlagWithDefault(featureFlag, defaultValue) {
  const flags = window.scConfig && window.scConfig.flags || {};
  return featureFlag in flags ? flags[featureFlag] : defaultValue;
}
